
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21.3","height":"27.892"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 173","transform":"translate(-244.35 -367.758)","fill":"none","stroke":"#fff","stroke-width":"1.3"}},[_c('rect',{attrs:{"data-name":"Rechteck 78","width":"20","height":"24","rx":"2","transform":"translate(245 371)","stroke-linejoin":"round"}}),_c('path',{attrs:{"data-name":"Pfad 122","d":"M259.19 370.651v1.682a1.682 1.682 0 01-1.682 1.682h-5.607a1.682 1.682 0 01-1.682-1.682v-1.682","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Pfad 123","d":"M252.462 370.651a2.243 2.243 0 014.485 0","stroke-miterlimit":"10"}}),_c('rect',{attrs:{"data-name":"Rechteck 80","width":"6","height":"6","rx":"2","transform":"translate(248 378)","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('rect',{attrs:{"data-name":"Rechteck 81","width":"6","height":"6","rx":"2","transform":"translate(256 378)","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('rect',{attrs:{"data-name":"Rechteck 82","width":"6","height":"6","rx":"2","transform":"translate(248 386)","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    